import { useState, useEffect } from "react";

// Rotating editorial portraits of women of color across a range of shades —
// mirrors the Brotherhood+ sign-in imagery, tailored for Sisterhood+.
const IMAGES = [
  "https://images.unsplash.com/photo-1632765866070-3fadf25d3d5b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  "https://images.unsplash.com/photo-1684361436003-aa575b96bc2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  "https://images.unsplash.com/photo-1639325723366-1759d5d74959?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  "https://images.unsplash.com/photo-1594089425711-2381a2fbca6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  "https://images.unsplash.com/photo-1593351799227-75df2026356b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
];

export default function RotatingHero() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % IMAGES.length), 4200);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="absolute inset-0" data-testid="auth-rotating-hero">
      {IMAGES.map((src, i) => (
        <img key={src} src={src} alt="A woman in warm, reflective light"
          className="absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 animate-kenburns"
          style={{ opacity: i === idx ? 1 : 0 }} />
      ))}
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2 z-20">
        {IMAGES.map((_, i) => (
          <span key={i} className={`h-1.5 rounded-full transition-all ${i === idx ? "w-6 bg-[#C89B55]" : "w-1.5 bg-white/50"}`} />
        ))}
      </div>
    </div>
  );
}
